/**
 * Take a device, show info about it and show its logs.
 *
 * Used inside device_pane_layout to show logs and controls
 * for logs for a single device.
 *
 * Logging for Code Editor & Device Details
 *
 */
import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DeviceInfoView from '@/views/device_breadcrumb_info_view';
import LoggingView from '@/views/logging_view';
import template from '@/../templates/device-log-info.hbs';

    var DeviceLogInfoView = Marionette.View.extend({
        template: Handlebars.compile(template),
        regions: {
            device_info: '.device-info-region',
            logs: '.logs-region'
        },
        ui: {
            clear_log_button: '.controls .clear',
            pause_button: '.controls .pause',
            lock_icon: '.controls .lock',
        },
        events: {
            'click @ui.clear_log_button': 'onclick_clear_log_button',
            'click @ui.pause_button': 'onclick_pause_button'
        },
        initialize: function () {
            // create local storage key value
            if (!localStorage.getItem('paused_devices')) {
                localStorage.setItem('paused_devices', JSON.stringify(new Array));
            }
        },
        logging_enabled: function () {
            var paused_devices = JSON.parse(localStorage.getItem('paused_devices'));
            // If not included in the local storage array, its currently enabled. return true
            if (!paused_devices.includes(this.model.get('id'))) {
                return true;
            } else {
                return false;
            }
        },
        toggle_logging: function() {
            var paused_devices = JSON.parse(localStorage.getItem('paused_devices'));
            // If not included in the local storage array, its currently enabled. return true
            if (!paused_devices.includes(this.model.get('id'))) {
                paused_devices.push(this.model.get('id'));
                localStorage.setItem('paused_devices', JSON.stringify(paused_devices));
                return true;
                // If its in the array its currently disabled. return false
            } else {
                paused_devices = _.without(paused_devices, this.model.get('id'));
                localStorage.setItem('paused_devices', JSON.stringify(paused_devices));
                return false;
            }
        },
        onRender: function() {
            this.show_device_info(this.model);
            this.show_logs(this.model);
        },
        show_device_info: function(device) {
            var device_info_view = new DeviceInfoView({
                model: device
            });

            this.showChildView('device_info', device_info_view);
        },
        show_logs: function(device) {
            var logging_view = new LoggingView({
                model: device,
            });
            this.listenTo(logging_view, 'lock', this.log_locked);
            this.listenTo(logging_view, 'unlock', this.log_unlocked);
            this.showChildView('logs', logging_view);
        },
        onclick_clear_log_button: function() {
            var logging_view = this.getRegion('logs').currentView;
            if (!logging_view || !logging_view.clear_log) { return; }

            logging_view.clear_log();
        },
        onclick_pause_button: function() {
            var logging_view = this.getRegion('logs').currentView;
            if (!logging_view || !logging_view.enable_log) { return; }

            if (this.logging_enabled()) {
                this.ui.pause_button.addClass('active');
                logging_view.disable_log(this.model);
            } else {
                this.ui.pause_button.removeClass('active');
                logging_view.enable_log(this.model);
            }
            this.toggle_logging();
        },
        handle_syntax_check_results: function(results) {
            var logging_view = this.getRegion('logs').currentView;
            if (!logging_view) return;
            
            Object.keys(results).forEach(function(code_type) {
                results[code_type].forEach(function(result) {
                    logging_view.addSyntaxErrorLog(code_type, result.row, result.text, result.type);
                }, this);
            }, this);
        }
    });
    export default DeviceLogInfoView;

